import API from "@constants/API";

const BASE_URL = "https://api.prod.daily.co.id/dashboard/feedback/v3/feedbacks";

export const getReviewsApi = async () => {
  const response = await API.HTTP.get(BASE_URL);
  return response.data;
};
